module.exports = __webpack_public_path__ + "img/profile-image-default.7b28486a.jpeg";